interface DateRange {
  start: string
  end: string
}

type OutcomeFilter = 'all' | 'wins' | 'losses'
type SignalFilter = 'all' | 'entry' | 'strong'

interface Props {
  dateRange: DateRange
  onDateRangeChange: (range: DateRange) => void
  outcomeFilter: OutcomeFilter
  onOutcomeFilterChange: (filter: OutcomeFilter) => void
  signalFilter: SignalFilter
  onSignalFilterChange: (filter: SignalFilter) => void
  onReset: () => void
}

export function StrategyFilterBar({
  dateRange,
  onDateRangeChange,
  outcomeFilter,
  onOutcomeFilterChange,
  signalFilter,
  onSignalFilterChange,
  onReset,
}: Props) {
  return (
    <div className="strategy-filter-bar">
      <div className="strategy-filter-group">
        <input
          type="date"
          className="strategy-date-input"
          value={dateRange.start}
          onChange={e => onDateRangeChange({ ...dateRange, start: e.target.value })}
        />
        <span className="strategy-filter-sep">to</span>
        <input
          type="date"
          className="strategy-date-input"
          value={dateRange.end}
          onChange={e => onDateRangeChange({ ...dateRange, end: e.target.value })}
        />
      </div>

      <div className="journal-view-toggle">
        {(['all', 'wins', 'losses'] as OutcomeFilter[]).map(f => (
          <button
            key={f}
            className={outcomeFilter === f ? 'active' : ''}
            onClick={() => onOutcomeFilterChange(f)}
          >
            {f === 'all' ? 'All' : f === 'wins' ? 'Wins' : 'Losses'}
          </button>
        ))}
      </div>

      <div className="journal-view-toggle">
        {(['all', 'entry', 'strong'] as SignalFilter[]).map(f => (
          <button
            key={f}
            className={signalFilter === f ? 'active' : ''}
            onClick={() => onSignalFilterChange(f)}
          >
            {f === 'all' ? 'All' : f === 'entry' ? 'Entry 65+' : 'Strong 80+'}
          </button>
        ))}
      </div>

      <button className="journal-btn" onClick={onReset}>Reset</button>
    </div>
  )
}

export type { DateRange, OutcomeFilter, SignalFilter }
